import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { EMPTY, interval } from 'rxjs';
import { DashboarduiService } from '../Shared/Service/dashboardui.service';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatPaginator, MatSelectChange, MatSort, MatTableDataSource } from '@angular/material';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import beautify from 'xml-beautifier';
import { ExcelServicesService } from '../Shared/Service/excel-services';
import { switchMap } from 'rxjs/operators';
export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
export class idsProductList {
  id: number;
  status: String;
  hotelName: String;
  accountingDate: any;
  pusheddate: any;
  type: any
  resStatus:any;
   ischecked?: number;
     // Add these missing fields
  request?: string;
  requestLogID?: string;
  channelName?: string;
  rowkey?: string;
  channelDestinationURL?: string;
}
@Component({
  selector: 'app-channelreservationsummary',
  templateUrl: './channelreservationsummary.component.html',
  styleUrls: ['./channelreservationsummary.component.css'],
      providers: [
          {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
          },
      
          { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
        ]
    })
export class ChannelreservationsummaryComponent implements OnInit {
cmList: any[] = [];
pmsList: any[] = [];
selectedCM: string = 'ALL';
selectedPMS: any[] = [{ pmscode: 'ALL', pmsname: 'All Properties' }];//[];//
  
  distinctStatusList: string[] = [];//Indhuja 25-11-2025
  distinctResStatusList:string[]=[];
    isProgressing: Boolean = false;
      Userid: any = [];
      apiresult: any;
      hotellist: any = [] = [];
      dropdownDeptData: any;
      hotellistproperty: any;
      heartBeatData: any;
      selectedDeptItems: any;
      searchBarFilter: boolean = false;
      ValSearchDownload: string;
      totalcount: any = 0;
      public Pmscodevalue: any;
      constructor(  private apiCallIdsService: DashboarduiService,private datePipe: DatePipe,private toastr: ToastrService,private excelService: ExcelServicesService) { }
      hideSearchFilter(){
        this.ValSearchDownload = '';
        this.searchBarFilter = false
      }
      errorMsgSubscription: boolean;
      displayContent: boolean;
      errorMessage: string;
      addBtnDisabledFunc: boolean = true;
      hotelSearchDataStatus: any;
      productType: any;
      currentDateStore: any;
      storeHeartBeatValue: any;
      blinkOfflineHotel: boolean;
      excelFunction: boolean = false;
      lstgetcmlist: any = [];
      PGF: any = "0";
      PGT: any = "50";
      selectedChannel: any;
      dropdownSettingsDept: IDropdownSettings = {};
      lstBookingCopy: any = [] = [];
      lstBooking: any = [] = [];
      selectedDate: any = new Date();
      selectedTOODate: any = new Date();
      fromMinDate:Date=new Date(2026, 0 ,11)
      searchValueData: any;
      filterProperty: any;
      pageSize = 50;
      idsProductList: idsProductList[] = [];
      dataSource: MatTableDataSource<idsProductList>
      @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
      @ViewChild(MatSort, { static: true }) sort: MatSort;
      status: any = [] = [];
      XMLName: any;
      display: Boolean = false;
      defaultData: any = [] = [];
      XMLTitle: string;
      today = new Date();
      popupDataSource = new MatTableDataSource<any>();
      loginUserID: any;
      bulkresynflag: boolean = false;
      transactionType: string = 'Download';
      selectedRange = '10';
   /*   dateRanges = [
  { text: 'Last 10 Days', value: '10' },
  { text: 'Last 15 Days', value: '15' },
  { text: 'Last 20 Days', value: '20' },
  { text: 'Last 30 Days', value: '30' },
  { text: 'Last 50 Days', value: '50' },
  { text: 'Last 100 Days', value: '100' },
  { text: 'Custom', value: 'custom' }
]; */
  displayedColumnspopup: string[] = [
      'StandardObject','Response','ReservationID','PmsConfirmation','StatusDescription','RequestDatetime','ResponseDatetime'
    ];
        displayedColumns: string[] = ['Echotoken','channelName','PMSCode','OTA#', 'PMS#', 'guestName', 'resstatus', 'status','StatusDescription', 'bookingCreatedTime','channelRequesttime','responseDatetime','confirmationReqDatetime','uploadRequestDatetime','pmsReqDatetime','pmsConfirmationTime','ChannelResTimeInterval','ChannelConfirmationTimeInterval','ChannelPMSTimeInterval','DHPMSTimeInterval'];//,,'resack'
      ngOnInit() {
        this.loginUserID = localStorage.getItem("Username");
      console.log('loging',this.loginUserID)
    if(this.loginUserID =='ramesh.k@idsnext.com'||this.loginUserID =='jegatheesan.p@idsnext.com'||this.loginUserID=='indhuja.r@idsnext.com'){
        this.bulkresynflag = true 
      }else{
        this.bulkresynflag = false
      } 
  
  
  
  
        this.ValSearchDownload = ''
        this.callIDSUsersProperties();
        this.dropdownSettingsDept = {
          idField: 'pmscode',
          textField: 'pmsname',
          allowSearchFilter: true,
          singleSelection: true,
          enableCheckAll: false,
          closeDropDownOnSelection: true,
          itemsShowLimit: 7,
          noDataAvailablePlaceholderText: 'No Data Found',
          searchPlaceholderText: "Search Hotel Code / Name"
        };
    }
  /* callIDSUsersPropertiesOld() {
    this.isProgressing = true;
  
    this.apiCallIdsService.getpropertydetailsPhaseIIEngine().subscribe({
      next: data => {
        // Deduplicate by cmcode + pmscode
        this.hotellist = data.filter(
          (v, i, a) =>
            a.findIndex(t => t.cmcode === v.cmcode && t.pmscode === v.pmscode) === i
        );
  
        // Build Channel dropdown
        this.cmList = Array.from(new Set(this.hotellist.map(x => x.cmcode)))
          .map(code => {
            const cmItem = this.hotellist.find(x => x.cmcode === code);
            return {
              cmcode: code,
              cmname: (cmItem && cmItem.cmname) ? cmItem.cmname : ''
            };
          });
        // Add “ALL” option
        this.cmList.unshift({ cmcode: 'ALL', cmname: 'All Channels' });
  
        // Initial PMS list (all properties)
        this.pmsList = Array.from(new Set(this.hotellist.map(x => x.pmscode)))
          .map(pmscode => {
            const pmsItem = this.hotellist.find(x => x.pmscode === pmscode);
            return {
              pmscode: pmscode,
              pmsname: (pmsItem && pmsItem.pmsname) ? pmsItem.pmsname : ''
            };
          });
               this.pmsList.unshift({
          pmscode: "All",
          pmsname: "All Properties"
        });
  
        this.isProgressing = false;
      },
      error: err => {
        console.error(err);
        this.isProgressing = false;
      }
    });
  } */
  
  /* onCMChangeOld(cmCode: string) {
    this.selectedCM = cmCode;
  
    // If “ALL” selected, include every PMS
    const filtered = cmCode === 'ALL'
        ? this.hotellist
        : this.hotellist.filter(x => x.cmcode === cmCode);
  
    // Build unique PMS list for the selected channel(s)
    this.pmsList = Array.from(new Set(filtered.map(x => x.pmscode)))
      .map(pmscode => {
        const pmsItem = filtered.find(x => x.pmscode === pmscode);
        return {
          //pmscode: pmscode,
           pmscode:pmsItem.chhotelcode||'',
          pmsname: (pmsItem && pmsItem.pmsname) ? pmsItem.pmsname : '',
          chhotelcode:pmsItem.chhotelcode||''
        };
      });
  this.pmsList.unshift({
          pmscode: "All",
          pmsname: "All Properties"
        });
    // Reset PMS selection so the user must choose again
    this.selectedPMS = [];
  } */
  callIDSUsersProperties() {
    this.isProgressing = true;
  
    this.apiCallIdsService.getpropertydetailsPhaseIIEngine().subscribe({
      next: (data: any[]) => {
  
        // Remove duplicates based on cmcode + pmscode
        this.hotellist = data.filter(
          (v: any, i: number, a: any[]) =>
            a.findIndex(
              (t: any) =>
                t.cmcode === v.cmcode &&
                t.pmscode === v.pmscode
            ) === i
        );
  
        const uniqueCM = new Map<string, any>();
  
        this.hotellist.forEach((item: any) => {
          if (!uniqueCM.has(item.cmcode)) {
            uniqueCM.set(item.cmcode, {
              cmcode: item.cmcode,
              cmname: item.cmname || ''
            });
          }
        });
  
        this.cmList = Array.from(uniqueCM.values());
  
        this.cmList.unshift({
          cmcode: 'ALL',
          cmname: 'All Channels'
        });
  
        // ==========================
        // PMS List
        // ==========================
        const uniquePMS = new Map<string, any>();
  
        this.hotellist.forEach((item: any) => {
          if (!uniquePMS.has(item.pmscode)) {
            uniquePMS.set(item.pmscode, {
              pmscode: item.pmscode,
              pmsname: item.pmsname || '',
              chhotelcode: item.chhotelcode || ''
            });
          }
        });
  
        this.pmsList = Array.from(uniquePMS.values());
  
        this.pmsList.unshift({
          pmscode: 'ALL',
          pmsname: 'All Properties',
          chhotelcode: ''
        });
  
        this.isProgressing = false;
      },
      error: (err: any) => {
        console.error('Error loading property details:', err);
        this.isProgressing = false;
      }
    });
  }
  
  onCMChange(cmCode: string) {
  
    this.selectedCM = cmCode;
  
    const filteredHotels =
      cmCode === 'ALL'
        ? this.hotellist
        : this.hotellist.filter((x: any) => x.cmcode === cmCode);
  
    const uniquePMS = new Map<string, any>();
  
    filteredHotels.forEach((item: any) => {
  
      if (!uniquePMS.has(item.pmscode)) {
  
        uniquePMS.set(item.pmscode, {
          pmscode: item.pmscode,
          pmsname: item.pmsname || '',
          chhotelcode: item.chhotelcode || ''
        });
  
      }
    });
  
    this.pmsList = Array.from(uniquePMS.values());
  
    this.pmsList.unshift({
      pmscode: 'ALL',
      pmsname: 'All Properties',
      chhotelcode: ''
    });
  
    // Reset PMS selection
    this.selectedPMS = [];
  }
  changePropertySearch() {
            if (this.selectedDeptItems) {
              if (this.selectedDeptItems.length > 0) {
                console.log('if condition')
                this.totalcount = 0
                this.Pmscodevalue = this.selectedDeptItems[0].pmscode
                console.log('pms code value = ', this.Pmscodevalue)
                this.errorMsgSubscription = true
                this.errorMessage = "Please select property and load"
                this.displayContent = false
        
                var result = this.apiresult.filter((obj: { pmscode: MatSelectChange; }) => obj.pmscode == this.Pmscodevalue);
                console.log('filter record = ', result);
                this.lstgetcmlist = result;
                this.selectedChannel = this.lstgetcmlist[0].cmcode;
                // For Online Status
                this.apiCallIdsService
                  .readHotelSearch(this.Pmscodevalue)
                  .subscribe((data) => {
                    console.log('readHotelSearch =', data)
                    this.hotelSearchDataStatus = data[0].recordstatus
                    this.productType = data[0].producttype
                  });
                this.apiCallIdsService
                  .readHeartbeat(this.Pmscodevalue)
                  .subscribe((data) => {
                    console.log('readHeartbeat =', data[0])
                    this.heartBeatData = data[0].heartBeat
        
        // For blinking the record
        const today = new Date()
        console.log('Today Date = ',today);
        this.currentDateStore = today.toLocaleTimeString('it-IT')
        console.log('Today Date = ',this.currentDateStore);
        this.storeHeartBeatValue = this.GetParseonlyDateTimeBlink(this.heartBeatData)
        var start = this.storeHeartBeatValue.split(":");
        var end = this.currentDateStore.split(":");
        var startDate = new Date(0, 0, 0, start[0], start[1], 0);
        var endDate = new Date(0, 0, 0, end[0], end[1], 0);
        var diff = endDate.getTime() - startDate.getTime();
        var hours = Math.floor(diff / 1000 / 60 / 60);
        diff -= hours * 1000 * 60 * 60;
        var minutes = Math.floor(diff / 1000 / 60);
        // console.log('minutes difference',minutes)
        console.log('minutes difference', hours + ":"  + minutes)
        if((hours + ":"  + minutes) > "0:30"){
          console.log('blinkOfflineHotel true')
          this.blinkOfflineHotel = true
        }else{
          console.log('blinkOfflineHotel false')
          this.blinkOfflineHotel = false
        }
        
        
                  });
                interval(2000 * 60).subscribe(() => {
                  this.heartbeatFunction();
                });
              } else {
                console.log('Else condition zero')
                this.errorMsgSubscription = true
                this.errorMessage = "Please select property and load"
                this.displayContent = false
              }
            } else {
              console.log('Property Not Selected')
            }
          }
        
          heartbeatFunction(){
            this.apiCallIdsService
            .readHeartbeat(this.Pmscodevalue)
            .subscribe((data) => {
              console.log('readHeartbeat =',data[0])
              this.heartBeatData = data[0].heartBeat
            });
          }
          GetParseonlyDateTimeBlink(d:any) {
            console.log('GetParseonlyDateTime call',d.substring(12))
            return (d.substring(12));
          }
          GetCommonMethodForLog(ValSearchDownload:any) {
            console.log('ValSearchDownload = ',ValSearchDownload)
            this.searchValueData = ValSearchDownload
            this.PGF = "0";
            this.PGT = "50";
            this.GetBooking()
        
          }
          GetBooking() {
            if (!this.selectedPMS || this.selectedPMS.length === 0) {
      this.toastr.error('Please select property and load');//(PMS Code) before loading.
      return; 
    }
            console.log(this.selectedChannel)
            console.log(this.Pmscodevalue)
            this.isProgressing = true;
            this.lstBooking = [];
            this.lstBookingCopy = [];
            this.selectedDate = this.datePipe.transform(this.selectedDate, 'yyyy-MM-dd');
            this.selectedTOODate = this.datePipe.transform(this.selectedTOODate, 'yyyy-MM-dd');
            if (this.selectedTOODate < this.selectedDate) {
              this.isProgressing = false;
              this.toastr.error('From date should be less than To date.');
            }
            else {
              this.selectedTOODate = this.datePipe.transform(this.selectedTOODate, 'yyyy-MM-dd');
            const channelCode = this.selectedCM || 'ALL';
    const pmsCode = this.selectedPMS && this.selectedPMS.length > 0 
                    ? this.selectedPMS.map(x => x.pmscode).join(',') 
                    : 'ALL';
  
    console.log('Selected Channel:', channelCode);
    console.log('Selected PMS:', pmsCode);
  const transactionType=this.transactionType||'';
  
        console.log('searchValueData =',this.searchValueData)//this.Pmscodevalue,
        if (this.selectedRange !== 'custom') {

          const today = new Date();
          const from = new Date();

          from.setDate(today.getDate() - Number(this.selectedRange));

          this.selectedDate = from;
          this.selectedTOODate = today;
        }

        const fromDate = this.datePipe.transform(this.selectedDate, 'yyyy-MM-dd');
        const toDate = this.datePipe.transform(this.selectedTOODate, 'yyyy-MM-dd');
        console.log("fromdate",fromDate)
        console.log("toDate",toDate)
        this.apiCallIdsService.ReadChannelSummaryTblPhaseII(pmsCode, channelCode, fromDate, toDate,this.PGF, this.PGT,this.searchValueData,transactionType) 
           // this.apiCallIdsService.readphaseIIwithresyncdatetime(pmsCode, channelCode, this.selectedDate, this.selectedTOODate,this.PGF, this.PGT,this.searchValueData)
              .subscribe(
                data => {
                        /* Manually insert ischecked as 0 */
                        for (let i = 0; i < data.length; i++) {
                          data[i]['ischecked'] = 0
                       }
                       console.log('After insert ischecked',data);
                       console.log('data.length',data.length);
                  if (data.length < 1 || data[0].totalCount == 0){
                    this.displayContent = false
                    this.errorMsgSubscription = true
                    this.errorMessage = "No Data Found"
                    this.toastr.error('No Data Found');
                    this.isProgressing = false;
                    this.excelFunction = false
                  }else{
                    this.errorMsgSubscription = false
                    this.displayContent = true
                    this.filterProperty = data
                    this.idsProductList = data;
                    this.totalcount = data[0].totalCount
                    this.dataSource = new MatTableDataSource(this.idsProductList);
                    console.log('dataSource = ',this.dataSource);
                    this.dataSource.paginator = this.paginator;
                    this.distinctStatusList = [...new Set(
    this.idsProductList.map(x =>
      ((x.status && x.status.trim()) || "Pending")
    )
  )];
  
                   // this.distinctStatusList = [...new Set(this.idsProductList.map(x => String(x.status)))];
                    //this.distinctResStatusList = [...new Set(this.idsProductList.map(x => String(x.resStatus)))];
                    this.distinctResStatusList= [...new Set(
    this.idsProductList.map(x =>
      ((x.resStatus && x.resStatus.trim()) || "Pending")
    )
  )];
                    console.log("Distinct Status Values:", this.distinctStatusList);
                    console.log("Distinct Resstatus Values :",this.distinctResStatusList)
                    this.toastr.success('Data Loaded Successfully');
                    this.isProgressing = false;
                    this.excelFunction = true;
                  }
                });
              }
          }
          pageEvent(e:any) {
            console.log('pageEvent = ', e)
            var pageIndex = e.pageIndex;
            pageIndex = pageIndex;
            console.log('pageIndex = ', pageIndex)
            this.pageSize = e.pageSize
            console.log('pageSize = ', this.pageSize)
            this.PGF = this.pageSize * pageIndex + 1;
            this.PGT = this.PGF + e.pageSize - 1;
            console.log("this.PGF", this.PGF)
            console.log("this.PGT", this.PGT)
            this.GetBooking();
          }
          
          closeModalDialog() {
            this.display = false; //set none css after close dialog
          }
        
  downloadJSON(fileUrl: string, prefix: string) {
    if (!fileUrl) {
      this.toastr.error('No data found');
      return;
    }
  
    this.isProgressing = true;
  
    // Call your API that proxies the Azure file (you already have loadXMLData)
    this.apiCallIdsService.loadXMLData(fileUrl).subscribe({
      next: (res: any) => {
        // If your backend returns { content: "<file text>" }
        const fileContent =
          typeof res.content === 'string'
            ? res.content
            : JSON.stringify(res.content, null, 2);
  
        const blob = new Blob([fileContent], { type: 'text/plain' });
        const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
        const filename = `${prefix}_${timestamp}.txt`;
  
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
  
        this.isProgressing = false;
      },
      error: err => {
        console.error('Download error', err);
        this.toastr.error('Failed to download file');
        this.isProgressing = false;
      }
    });
  }
  
  openJsonPopup(request:string, requestLogID: string,prefix: string,cmcode:string) {
    this.isProgressing = true;
    console.log("cmcode",cmcode);
    this.apiCallIdsService.readPhaseIIEnginegetchannellog(requestLogID,cmcode).subscribe({
      next: (res: any[]) => {
        this.isProgressing = false;
        if (res && res.length > 0) {
        //  this.downloadJSON(request,prefix);
          this.XMLName = 'API Details';
          this.popupDataSource = new MatTableDataSource(res);
          this.display = true; 
        }
      },
      error: () => {
        this.isProgressing = false;
        this.toastr.error('Failed to fetch JSON data.');
      }
    });
  }
  onResyncold(element: any) {
    const requestUrl = element.request;  // <-- URL from 'request' column
    const requestLogID = element.requestLogID;
    const channelName  = element.channelName; 
    const RowKey=element.rowkey // just pass the URL
    const channelurl=element.channelDestinationURL;
  console.log("url",requestUrl)
  console.log("request",element)
    this.isProgressing = true;
  
    // Call backend API that handles download + resync
    this.apiCallIdsService.phaseIINewTBLResyncAPI(requestUrl,requestLogID,channelName,RowKey,this.loginUserID,channelurl).subscribe(
      res => {
        console.log("Phase II Resync API Response:", res);
        this.toastr.success("Resync completed successfully!");
       this.GetBooking();
        this.isProgressing = false;
      },
      err => {
        console.error("Error in Phase II Resync API:", err);
        this.toastr.error("Resync failed!");
        this.isProgressing = false;
      }
    );
  }
  onResyncwithstatus(element: any) {
    const requestUrl = element.request;  // <-- URL from 'request' column
    const requestLogID = element.requestLogID;
    const channelName  = element.channelName; 
    const RowKey=element.rowkey // just pass the URL
    const channelurl=element.channelDestinationURL;
  console.log("url",requestUrl)
  console.log("request",element)
    this.isProgressing = true;
  
    // Call backend API that handles download + resync
    this.apiCallIdsService.phaseIINewTBLResyncAPI(requestUrl,requestLogID,channelName,RowKey,this.loginUserID,channelurl).subscribe(
      res => {
        if (res && res.length > 0) {
          if (res[0].status === "Success") {
            this.toastr.success(res[0].statusDescription);
            this.GetBooking();
          } else {
            this.toastr.error(res[0].statusDescription);
          }
        } else {
          this.toastr.error("Invalid API response.");
        }
         this.isProgressing = false;
      },
      (err) => {
        console.error("Error in Phase II Resync API:", err);
        this.toastr.error("Resync failed!");
        this.isProgressing = false;
      }
    );
  }
  onResync(element: any) {

  // Emma cannot be processed when All Properties and All Channels are selected
  
 /*  const isAllProperty =
    this.selectedPMS &&
    this.selectedPMS.length > 0 &&
    this.selectedPMS[0].pmscode === "ALL";

  const isAllChannel =
    this.selectedCM === "ALL" ||
    (element.channelName &&
      element.channelName.toUpperCase() === "ALL");

  if (isAllProperty || isAllChannel) {
    this.toastr.warning(
      "Emma will not be processed when All Properties and All Channels are selected."
    );
    return;
  } */
  const requestUrl = element.request;
  const requestLogID = element.requestLogID;
  const channelName = element.channelName;
  const RowKey = element.rowkey;
  const channelurl = element.channelDestinationURL;

  this.isProgressing = true;

  this.apiCallIdsService
    .phaseIINewTBLResyncAPI(
      requestUrl,
      requestLogID,
      channelName,
      RowKey,
      this.loginUserID,
      channelurl
    )
    .subscribe(
      (res: any) => {
        if (res && res.length > 0) {
          if (res[0].status === "Success") {
            this.toastr.success(res[0].statusDescription);
            this.GetBooking();
          } else {
            this.toastr.error(res[0].statusDescription);
          }
        } else {
          this.toastr.error("Invalid API response.");
        }

        this.isProgressing = false;
      },
      (err) => {
        this.toastr.error("Resync failed!");
        this.isProgressing = false;
      }
    );
}
  onReActivate()
  {
    this.toastr.warning("Under Development");
    this.isProgressing=false;
  }
  
  //Indhuja 09-12-2025
   bulkResync() {
    if (!this.idsProductList || this.idsProductList.length === 0) {
      this.toastr.error("No data to resync. Please load data first.");
      return;
    }
     /* const from = new Date(this.selectedDate);
    const to = new Date(this.selectedTOODate);
  
    const today = new Date();
    const fiveDaysAgo = new Date();
    fiveDaysAgo.setDate(today.getDate() - 5);
  
    // Check if selected range is older than 5 days
    if (from < fiveDaysAgo || to < fiveDaysAgo) {
      this.toastr.error("You can resync only data from the past 5 days.");
      return;
    } */
   
    const from = new Date(this.selectedDate);
    const to = new Date(this.selectedTOODate);
  
    const today = new Date();
    today.setHours(0,0,0,0);
  
    const fiveDaysAgo = new Date();
    fiveDaysAgo.setDate(today.getDate() - 6);
    fiveDaysAgo.setHours(0,0,0,0);
  console.log("from",from,"to",to,"firsrday",fiveDaysAgo)
    // ❌ Block future dates
   /*  if (from > today || to > today) {
      this.toastr.error("Future dates are not allowed.");
      return;
    } */
  
    // ❌ Block dates older than 5 days
  /*   if (from < fiveDaysAgo || to < fiveDaysAgo) {
      this.toastr.error("Only past 5 days data is allowed.");
      return;
    } */
  const diffTime = to.getTime() - from.getTime();
    const diffDays = diffTime / (1000 * 60 * 60 * 24) + 1; // +1 to include both from and to
    if (diffDays > 5) {
      this.toastr.error("Selected date range cannot exceed 5 days.");
      return;
    }
    // If it's here → valid
    console.log("Date range valid: within past 5 days");
  console.log("idsbulkresyn",this.idsProductList)
    // Map loaded data to bulk request format
     const bulkRequest = this.dataSource.filteredData.map(element => ({
      RequestUrl: element.request,
      RequestLogID: element.requestLogID,
      channelName: element.channelName,
      RowKey: element.rowkey,
      APIUrl: element.channelDestinationURL
    }));
    console.log("Bulk Request:", bulkRequest);
  
    this.isProgressing = true;
  
    this.apiCallIdsService.savePhaseIIBulkResync(bulkRequest)
      .subscribe({
        next: res => {
          this.toastr.success("Bulk Resync triggered successfully!");
          this.isProgressing = false;
  
          // Optional: refresh table after resync
          this.refreshAfterBulkResync();
        },
        error: err => {
          console.error(err);
          this.toastr.error("Failed to trigger bulk resync");
          this.isProgressing = false;
        }
      });
  }
  
  refreshAfterBulkResync() {
    const channelCode = this.selectedCM || 'ALL';
    const pmsCode = this.selectedPMS && this.selectedPMS.length > 0 
                    ? this.selectedPMS.map(x => x.pmscode).join(',') 
                    : 'ALL';
  
    this.isProgressing = true;
  this.apiCallIdsService.readphaseIIwithresyncdatetimeNew(
    //this.apiCallIdsService.readphaseIIwithresyncdatetime(
        pmsCode,
        channelCode,
        this.selectedDate,
        this.selectedTOODate,
        this.PGF,
        this.PGT,
        this.searchValueData,
        this.transactionType
    ).subscribe(data => {
        // Assign new data
        this.idsProductList = data;
  
        // Update table
        this.dataSource = new MatTableDataSource(this.idsProductList);
        this.dataSource.paginator = this.paginator;
  
        this.toastr.success("Data refreshed after resync!");
        this.isProgressing = false;
    });
  }
  openDropdown = false;
  openResStatusDropdown = false;
  toggleStatusDropdown() {
    this.openDropdown = !this.openDropdown;
       this.openResStatusDropdown = false;
  }
  toggleResStatusDropdown() {
    this.openResStatusDropdown = !this.openResStatusDropdown;
      this.openDropdown = false;
  }
  selectedStatus:string;
   selectedResStatus :string;
  applyStatusFilter(status: string) {
    this.selectedStatus = status;
    this.openDropdown = false; // close Status dropdown immediately
      this.openResStatusDropdown = false;
    this.applyCombinedFilter();
  }
  
  applyResStatusFilter(resStatus: string) {
    this.selectedResStatus = resStatus;
      this.openDropdown = false;
    this.openResStatusDropdown = false; // close ResStatus dropdown immediately
    this.applyCombinedFilter();
  }
  applyCombinedFilter() {
    this.dataSource.data = this.idsProductList.filter(x => {
  
      const normalizedStatus =
        (x.status && x.status.trim()) || "Pending";
  
      const normalizedResStatus =
        (x.resStatus && x.resStatus.trim()) || "Pending";
  
      const statusMatch =
        !this.selectedStatus ||
        normalizedStatus.toLowerCase() === this.selectedStatus.toLowerCase();
  
      const resStatusMatch =
        !this.selectedResStatus ||
        normalizedResStatus.toLowerCase() === this.selectedResStatus.toLowerCase();
  
      return statusMatch && resStatusMatch;
    });
  
    this.totalcount = this.dataSource.data.length;
  
    if (this.paginator) {
      this.paginator.firstPage();
    }
  
    console.log("Filtered Count:", this.totalcount);
  }
  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const clickedInside = (event.target as HTMLElement).closest('.status-filter-buttons');
    if (!clickedInside) {
      this.openResStatusDropdown = false;
    }
  }
  //Indhuja 24.02.2026 Start
  exportAsXLSX_oLD() {
      this.Userid = localStorage.getItem("Username");
      console.log(this.Userid)
      var filterArray = [];
      var slno = 1;
      const excelTitle = "Bookings from Channels FN Phase II";
      const excelDownloadTitle = "Bookings from Channels FN Phase II";
      const title = "Title: " + excelTitle;
      const role = "Role: " + "IDS User";
      const bindFirstName = "EmailId: " + this.Userid;
       const header = ['S.NO','Hotel Code','Echotoken','Channel','OTA#', 'PMS#','GuestName', 'ResStatus','FN Status','FN Remarks','FX Status','FX Remarks','CreatedDate','ResyncDate','ChannelRequest','DH Resp	Channel','RespAck'];
        for (var i in this.filterProperty) {
        filterArray.push([
          slno,this.filterProperty[i].channelHotelcode,this.filterProperty[i].echotoken,this.filterProperty[i].channelName,this.filterProperty[i].ota,this.filterProperty[i].pms,this.filterProperty[i].guestname,this.filterProperty[i].echotoken ,this.filterProperty[i].status,this.filterProperty[i].statusDescription, this.filterProperty[i].fdStatus,this.filterProperty[i].fdStatusDescription,this.datePipe.transform(this.filterProperty[i].requestDatetime, 'dd-MMM-yyyy, HH:mm'),this.datePipe.transform(this.filterProperty[i].resyncDateTime, 'dd-MMM-yyyy, HH:mm'),"JSON","JSON","JSON"
        ])
        slno = slno + 1;
      }
  
      this.excelService.ExcelBookingfromchanneltofxfnphaseII(filterArray, bindFirstName, title, role, header, excelTitle, excelDownloadTitle);
    }
      //Indhuja 24.02.2026 End
     
    exportAsXLSX() {
  
    this.isProgressing = true;
  
    var channelCode = this.selectedCM ? this.selectedCM : 'ALL';
  
    var pmsCode = 'ALL';
    if (this.selectedPMS && this.selectedPMS.length > 0) {
      pmsCode = this.selectedPMS.map(function(x: any) {
        return x.pmscode;
      }).join(',');
    }
  
    var fromDate = this.datePipe.transform(this.selectedDate, 'yyyy-MM-dd');
    var toDate = this.datePipe.transform(this.selectedTOODate, 'yyyy-MM-dd');
  
    // First call to get totalCount
    this.apiCallIdsService
      .readphaseIIReportsYearTBLNew(
        pmsCode,
        channelCode,
        fromDate,
        toDate,
        1,
        10,
        this.searchValueData,
        this.transactionType
      )
      .subscribe((res: any) => {
  
        var totalCount = res.totalCount; 
  
        // Now call again with full range
        this.apiCallIdsService
          .readphaseIIReportsYearTBLNew(
            pmsCode,
            channelCode,
            fromDate,
            toDate,
            1,
            15000 ,//totalCount
            this.searchValueData,
            this.transactionType
          )
          .subscribe((fullData: any) => {
  
            this.isProgressing = false;
            this.generateExcelFullData(fullData.data || fullData);
          });
  
      });
  }
  exportAsXLSXNewAPI() {

  this.isProgressing = true;

  let channelCode = this.selectedCM ? this.selectedCM : 'ALL';

  let pmsCode = 'ALL';

  if (this.selectedPMS && this.selectedPMS.length > 0) {
    pmsCode = this.selectedPMS
      .map((x: any) => x.pmscode)
      .join(',');
  }

  const fromDate = this.datePipe.transform(
    this.selectedDate,
    'yyyy-MM-dd'
  );

  const toDate = this.datePipe.transform(
    this.selectedTOODate,
    'yyyy-MM-dd'
  );

  this.apiCallIdsService
    .readphaseIIExcelReportsYearTBLNew(
      pmsCode,
      channelCode,
      fromDate,
      toDate,
      this.searchValueData,
      this.transactionType
    )
    .subscribe(
      (res: any) => {
        this.isProgressing = false;

        this.generateExcelFullData(res);
      },
      (error: any) => {
        this.isProgressing = false;

        console.error(error);
      }
    );
}
   generateExcelFullData(records: any[]) {
  
    if (!records || records.length === 0) {
      alert("No records found");
      return;
    }
  
    this.Userid = localStorage.getItem("Username");
  
    var filterArray = [];
    var slno = 1;
  
    const excelTitle = "Bookings from Channels FN Phase II";
    const excelDownloadTitle = "Bookings from Channels FN Phase II";
    const title = "Title: " + excelTitle;
    const role = "Role: IDS User";
    const bindFirstName = "EmailId: " + this.Userid;
  
    const header = [
      'S.NO','Hotel Code','Echotoken','Channel','OTA#',
      'PMS#','GuestName','ResStatus','FN Status','FN Remarks',
      'FX Status','FX Remarks','CDATE','CreatedDate','ResyncDate',
      'ChannelRequest','DH Resp Channel','RespAck'
    ];
  
    for (var i = 0; i < records.length; i++) {
  
      var row = records[i];
  
      filterArray.push([
        slno,
        row.channelHotelcode,
        row.echotoken,
        row.channelName,
        row.ota,
        row.pms,
        row.guestname,
        row.resStatus,
        row.status,
        row.statusDescription,
        row.fdStatus,
        row.fdStatusDescription,
        row.cdate,
        this.datePipe.transform(row.requestDatetime, 'dd-MMM-yyyy, HH:mm'),
        this.datePipe.transform(row.resyncDateTime, 'dd-MMM-yyyy, HH:mm'),
        "JSON",
        "JSON",
        "JSON"
      ]);
  
      slno++;
    }
  
    this.excelService.ExcelBookingfromchanneltofxfnphaseII(
      filterArray,
      bindFirstName,
      title,
      role,
      header,
      excelTitle,
      excelDownloadTitle
    );
  }
  
  exportAsXLSXx() {
  
    this.isProgressing = true;
  
    const payload = {
      channelCode: this.selectedCM ? this.selectedCM : 'ALL',
      pmscode: this.selectedPMS && this.selectedPMS.length > 0
        ? this.selectedPMS.map((x: any) => x.pmscode).join(',')
        : 'ALL',
      frmdate: this.datePipe.transform(this.selectedDate, 'yyyy-MM-dd'),
      toodate: this.datePipe.transform(this.selectedTOODate, 'yyyy-MM-dd')
    };
  
    this.apiCallIdsService.exportExcel2026(payload)
      .subscribe((response: any) => {
  
        this.isProgressing = false;
  
        const blob = new Blob([response], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
  
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'PhaseII_Report.xlsx';
        link.click();
      },
      error => {
        this.isProgressing = false;
        alert("Export failed");
      });
  }
  
  onDateRangeChange() {

  if (this.selectedRange === 'custom') {
    this.selectedDate = new Date();
    this.selectedTOODate = new Date();
    return;
  }

  const today = new Date();
  const from = new Date();

  from.setDate(today.getDate() - Number(this.selectedRange));

  this.selectedDate = from;
  this.selectedTOODate = today;
}
  onDateRangeChangeOld() {

  if (this.selectedRange === 'custom') {
    return;
  }

  const today = new Date();

  this.selectedTOODate = new Date(today);

  if (this.selectedRange === '0') {
    this.selectedDate = new Date(today);
    return;
  }

  if (this.selectedRange === '1') {

    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    this.selectedDate = yesterday;
    this.selectedTOODate = yesterday;

    return;
  }

  const from = new Date(today);
  from.setDate(today.getDate() - Number(this.selectedRange));

  this.selectedDate = from;
}

}
